/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled, alpha } from '@mui/system';
import { PROMETHEAN_NEUTRAL_WHITE, PROMETHEAN_PURPLE_GRAPE } from '../../styles/colors/colors';
export var StyledTableBaseWrapper = styled('div')(function () {
  return {
    '&.EmbersTable-root': {
      width: '100%',
      backgroundColor: PROMETHEAN_NEUTRAL_WHITE,
      position: 'relative',
      '.EmbersTableWrapper-root': {
        overflowX: 'hidden'
      },
      table: {
        tableLayout: 'fixed',
        minWidth: '100%',
        '.MuiTableCell-root.fixed-checkbox': {
          maxWidth: '48px',
          minWidth: '48px',
          '&>div': {
            width: '48px'
          }
        },
        '.EmbersCheckbox-noLabel': {
          '&:hover': {
            backgroundColor: alpha(PROMETHEAN_PURPLE_GRAPE, 0.1)
          }
        }
      },
      '::-webkit-scrollbar': {
        height: '12px'
      }
    }
  };
});